/**
 * Converts link of a SSL object to a link with only queries.
 *
 * To be used on routed dialogs for instance, when we need
 * to be able to redirect the user back to the object when
 * the dialog is closed.
 * @param {Object} link - Link to convert to query
 */
function linkToQuery(link) {
  // Retrieve the params without the profileUid
  const { profileUid, ...params } = link.params
  // Return a link with just a query object of the params
  return { query: params }
}

export default linkToQuery
